import React, { Component } from 'react';
import { Grid, Row, Col } from 'react-bootstrap';
import { connect } from 'react-redux';
import TickerSearch from './TickerSearch/TickerSearch';
import Dropdown from 'react-dropdown';
import './SubNav.css';

class SubNavStats extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showDetailsModal: false,
      showNewPortfolioModal: false
    };
  }

  render() {

    if (!this.props.auth.authenticated) return null;
    if (this.props.session.isAccountEmpty === null) return null;

    return (
      <Grid fluid id="sub-nav">
        <Row>
          <Col md={7} className="section section-left">

            <Dropdown
              value={this.props.currentOption}
              options={this.props.dropdownOptions}
              className="portfolio-dropdown"
              onChange={this.props.onDropdownSelect} />

          </Col>
          <Col md={5} className="section section-right">
            <TickerSearch />
          </Col>
        </Row>
      </Grid>
    );
  }
}

function mapStateToProps({ auth, session }) {
  return {
    auth,
    session
  }
}

export default connect(mapStateToProps, null)(SubNavStats);